module.exports = __webpack_public_path__ + "media/images/android-chrome-36x36-cbe239d70bebe6ef2036f9fa9ae4fa2e.png";